import { compose } from 'redux'

// higher-order components
import withEventHandlers from './withEventHandlers'
import withRedux from './withRedux'

// presentational component
import UI from './UI'

export default compose(withRedux, withEventHandlers)(UI)
